import SrEditor from "./SrEditor.vue";

SrEditor.install = function(Vue) {
  Vue.component(SrEditor.name, SrEditor);
};

export default SrEditor;



// WEBPACK FOOTER //
// ./packages/SrEditor/index.js